import { useContext } from 'react';
import { FlagContext } from '../FlagContext';
import { getEnabledFlagList } from '../helpers';
import { useDeepEqualMemo } from '../../../utils/hooks/useDeepEqualMemo';
export function useEnabledFlagList() {
    var flags = useContext(FlagContext);
    var flagList = useDeepEqualMemo(getEnabledFlagList(flags));
    return flagList;
}
//# sourceMappingURL=useEnabledFlagList.js.map